(() => {
const sizes = window.LynkPumpSleeveSizes || {
  "50624573079832": ["45068769689880"],
  "50624573112600": ["45068769689880"],
  "50624573145368": ["45068769722648"],
  "50624573178136": ["45068769722648"],
  "50624573210904": ["49281463222552"],
  "50624573243672": ["45068769689880"],
  "50624573276440": ["45068769689880"],
  "50624573309208": ["45068769722648"],
  "50624573341976": ["45068769722648"],
  "50624573374744": ["49281463222552"],
  "47417252184344": ["45068769689880"],
  "47417252217112": ["45068769689880"],
  "47417252249880": ["45068769722648"],
  "47417252282648": ["45068769722648"],
  "47417252315416": ["49281463222552"],
  "47417252348184": ["45068769689880"],
  "47417252380952": ["45068769689880"],
  "47417252413720": ["45068769722648"],
  "47417252446488": ["45068769722648"],
  "47417252479256": ["49281463222552"],
  "45068785287448": ["45068769689880"],
  "45068785320216": ["45068769689880"],
  "45068785352984": ["45068769722648"],
  "45068785385752": ["45068769722648"],
  "47413553332504": ["49281463222552"],
  "45068785418520": ["45068769689880"],
  "45068785451288": ["45068769689880"],
  "45068785484056": ["45068769722648"],
  "45068785516824": ["45068769722648"],
  "47413553365272": ["49281463222552"],
  "50621625139480": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "50621625172248": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068792824088": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068789383448": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068768936216": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068787286296": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068787843352": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068788400408": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068788433176": ["45068776276248", "45068774211864", "45068780470552", "45068780536088", "45068780601624", "45068777718040"],
  "45068786991384": ["45068776243480", "45068774179096", "45068780437784", "45068780503320", "45068780568856", "45068780470552", "45068780536088", "45068780601624", "45068777718040"]
};

  window.LynkPumpSleeveSizes = sizes;

  if (window.LynkPumpSleeveCompatibilityInitialized) {
    window.LynkPumpSleeveCompatibilityUpdate?.();
    return;
  }

  window.LynkPumpSleeveCompatibilityInitialized = true;

  const variantDetailsCache = new Map();

  const normalizeId = (id) => id?.toString();
  const compatibleSleeveIds = new Set(Object.values(sizes).flat().map(normalizeId));

  const getCompatibilityBlocks = () =>
    Array.from(document.querySelectorAll('[data-pump-sleeve-compatibility]'));

  const parseProductData = (block) => {
    const script = block.querySelector('[data-pump-sleeve-product]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Unable to parse pump sleeve compatibility product data', error);
      return null;
    }
  };

  const getCurrentVariantId = (block, productData) => {
    const productInfo = block.closest('product-info') || document;
    const inputValue = productInfo.querySelector('.product-variant-id')?.value;

    return normalizeId(inputValue || productData?.selectedVariantId);
  };

  const isSleeveProduct = (productData) => {
    if (productData?.productType === 'Vacuum Replacement Sleeve') return true;

    return productData?.variants?.some((variant) => compatibleSleeveIds.has(normalizeId(variant.id)));
  };

  const fetchVariantDetails = async (variantId) => {
    if (variantDetailsCache.has(variantId)) return variantDetailsCache.get(variantId);

    try {
      const response = await fetch(`/variants/${variantId}.js`);
      if (!response.ok) {
        variantDetailsCache.set(variantId, null);
        return null;
      }

      const variant = await response.json();
      const title = variant.name || variant.product_title || variant.title;
      if (!title) {
        variantDetailsCache.set(variantId, null);
        return null;
      }

      const details = {
        title,
        url: variant.url || `/variants/${variantId}`,
      };
      variantDetailsCache.set(variantId, details);

      return details;
    } catch (error) {
      console.error('Unable to fetch recommended sleeve title', error);
      variantDetailsCache.set(variantId, null);
      return null;
    }
  };

  const getPumpCartItems = (cart) =>
    cart?.items?.filter((item) => Object.prototype.hasOwnProperty.call(sizes, normalizeId(item.variant_id))) || [];

  const getCart = async () => {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
    if (!response.ok) throw new Error(`Cart returned ${response.status}`);

    return response.json();
  };

  const createCompatibilityItem = (status) => {
    const item = document.createElement('div');
    item.className = 'pump-sleeve-compatibility__item';
    item.dataset.compatibilityStatus = status;

    return item;
  };

  const createCompatibleMessage = (pumpTitle) => {
    const item = createCompatibilityItem('compatible');
    const strong = document.createElement('strong');
    strong.textContent = pumpTitle;
    item.append('This sleeve is compatible with ', strong, '.');

    return item;
  };

  const createIncompatibleMessage = (pumpTitle, sleeveDetails, localSleeves = []) => {
    const item = createCompatibilityItem('incompatible');
    const intro = document.createElement('p');
    intro.className = 'pump-sleeve-compatibility__intro';
    const strong = document.createElement('strong');
    strong.textContent = pumpTitle;

    if (localSleeves.length) {
      const sizeCounts = new Map();
      for (const sleeve of localSleeves) {
        sizeCounts.set(sleeve.size, (sizeCounts.get(sleeve.size) || 0) + 1);
      }
      const sizeNodes = [...sizeCounts.entries()].flatMap(([size, count], i) => {
        const article = count > 1 ? 'any ' : 'the ';
        const sizeEl = document.createElement('strong');
        sizeEl.textContent = size.toUpperCase();
        return i === 0 ? [article, sizeEl] : [' or ', article, sizeEl];
      });

      if (sleeveDetails.length) {
        intro.append('Choose ', ...sizeNodes, ' sleeve to be compatible with ', strong, ', or choose another suitable sleeve. ');
      } else {
        intro.append('Choose ', ...sizeNodes, ' sleeve to be compatible with ', strong, '.');
        item.append(intro);
        return item;
      }
    } else {
      intro.append('Choose a different size sleeve to be compatible with ', strong, '. ');
    }

    const toggle = document.createElement('button');
    const listId = `PumpSleeveCompatibility-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    toggle.type = 'button';
    toggle.className = 'pump-sleeve-compatibility__toggle link link--text';
    toggle.textContent = 'View suitable sleeves';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', listId);
    intro.append(toggle);

    const list = document.createElement('ul');
    list.id = listId;
    list.className = 'pump-sleeve-compatibility__list';
    list.hidden = true;

    sleeveDetails.forEach((sleeve) => {
      const listItem = document.createElement('li');
      const link = document.createElement('a');
      link.href = sleeve.url;
      link.textContent = sleeve.title;
      listItem.append(link);
      list.append(listItem);
    });

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', (!isExpanded).toString());
      toggle.textContent = isExpanded ? 'View suitable sleeves' : 'Hide suitable sleeves';
      list.hidden = isExpanded;
    });

    item.append(intro, list);

    return item;
  };

  const createPumpMessage = async (pumpItem, currentVariantId, productData) => {
    const pumpVariantId = normalizeId(pumpItem.variant_id);
    const pumpTitle = pumpItem.title || pumpItem.product_title || pumpItem.variant_title || 'pump';
    const recommendedSleeveIds = sizes[pumpVariantId] || [];
    const isCompatible = recommendedSleeveIds.includes(currentVariantId);

    if (isCompatible) {
      return createCompatibleMessage(pumpTitle);
    }

    const localCompatibleSleeves = [];
    const otherSleeveIds = [];

    for (const variantId of recommendedSleeveIds) {
      const normalizedId = normalizeId(variantId);
      const localVariant = productData?.variants?.find((v) => normalizeId(v.id) === normalizedId);
      if (localVariant) {
        localCompatibleSleeves.push({
          size: localVariant.sizeOption || (localVariant.title === 'Default Title' ? localVariant.productTitle : localVariant.title),
        });
      } else {
        otherSleeveIds.push(variantId);
      }
    }

    const recommendedSleeves = (
      await Promise.all(
        otherSleeveIds.map((variantId) => fetchVariantDetails(normalizeId(variantId)))
      )
    ).filter(Boolean);

    if (!localCompatibleSleeves.length && !recommendedSleeves.length) return null;

    return createIncompatibleMessage(pumpTitle, recommendedSleeves, localCompatibleSleeves);
  };

  const renderBlock = async (block, cart) => {
    const productData = parseProductData(block);
    const currentVariantId = getCurrentVariantId(block, productData);
    const message = block.querySelector('[data-pump-sleeve-compatibility-message]');

    if (!message || !currentVariantId || !isSleeveProduct(productData)) {
      block.hidden = true;
      return;
    }

    const pumpItems = getPumpCartItems(cart);
    if (!pumpItems.length) {
      block.hidden = true;
      return;
    }

    const pumpMessages = (
      await Promise.all(
        pumpItems.map((pumpItem) => createPumpMessage(pumpItem, currentVariantId, productData))
      )
    ).filter(Boolean);

    if (!pumpMessages.length) {
      block.hidden = true;
      return;
    }

    message.replaceChildren(...pumpMessages);
    block.hidden = false;
  };

  const updateCompatibilityMessages = async (cartData) => {
    const blocks = getCompatibilityBlocks();
    if (!blocks.length) return;

    try {
      const cart = cartData?.items ? cartData : await getCart();
      await Promise.all(blocks.map((block) => renderBlock(block, cart)));
    } catch (error) {
      console.error('Unable to update pump sleeve compatibility messages', error);
      blocks.forEach((block) => {
        block.hidden = true;
      });
    }
  };

  window.LynkPumpSleeveCompatibilityUpdate = updateCompatibilityMessages;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateCompatibilityMessages());
  } else {
    updateCompatibilityMessages();
  }

  document.addEventListener('product-info:loaded', () => updateCompatibilityMessages());

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => updateCompatibilityMessages());
    subscribe(PUB_SUB_EVENTS.variantChange, () => updateCompatibilityMessages());
  }
})();
